<style src="./GenreSelect.scss" lang="scss"></style>

<template lang="pug">
  section.genre-select(
    :class='{ "is-opened": !collapsed }'
  )
    header.genre-select__header(
      @click='toggle'
      tabindex='1'
    )
      h3.genre-select__title {{ direction.name }}
    .genre-select__body(
      v-if='!collapsed'
    )
      ul.genre-select__list
        li.genre-select__item(
          v-for='item in list'
          :key='item.id'
        )
          Checkbox(
            v-if='item.name'
            v-model='findItemById(item.id).selected' 
            :label='item.name'
            :name='item.name'
            :mods='["rounded"]'
          )
</template>

<script>
import Checkbox from "@/components/Checkbox/Checkbox";

export default {
  props: {
    direction: {
      required: true,
      type: Object
    },
    genres: {
      required: true,
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      list: this.genres,
      collapsed: false
    };
  },
  watch: {
    list: {
      deep: true,
      handler() {
        this.$emit("change", this.list);
      }
    }
  },
  components: { Checkbox },
  methods: {
    findItemById(id) {
      return this.list.find(item => item.id === id);
    },
    toggle() {
      this.collapsed = !this.collapsed;
    }
  }
};
</script>
